<app-organization-details></app-organization-details>

<div class="header-bar">
  <div class="navigation-items">
    <ng-container *ngFor="let tab of tabs">
      <button
        class="nav-button"
        routerLink="{{ tab.path }}"
        routerLinkActive="selected-route"
        [routerLinkActiveOptions]="{ exact: true }"
        *hasPrivilege="tab.privilege"
      >
        {{ tab.label }}
      </button>
    </ng-container>
  </div>
  <div class="page-actions">
    <app-portal-outlet name="organization-actions"></app-portal-outlet>
  </div>
</div>

<router-outlet></router-outlet>
